import { render, staticRenderFns } from "./baseSet.vue?vue&type=template&id=35d8b8f1&scoped=true&"
import script from "./baseSet.vue?vue&type=script&lang=js&"
export * from "./baseSet.vue?vue&type=script&lang=js&"
import style0 from "./baseSet.vue?vue&type=style&index=0&id=35d8b8f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8b8f1",
  null
  
)

export default component.exports